import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const DeviceErrorsPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.clients.pageHeader.titleListDetailError')} />
}

DeviceErrorsPageHeader.displayName = 'DeviceErrorsPageHeader'
export default DeviceErrorsPageHeader
